import { render } from "./CreatePRModalPricing.vue?vue&type=template&id=d870e406&scoped=true"
import script from "./CreatePRModalPricing.vue?vue&type=script&lang=js"
export * from "./CreatePRModalPricing.vue?vue&type=script&lang=js"

import "./CreatePRModalPricing.vue?vue&type=style&index=0&id=d870e406&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d870e406"]])

export default __exports__